<template>
  <div>
    <b-row class="row-padding">
      <b-col sm="3">
        <InputQuantity
          ref="quantidade"
          id="quantidade"
          label="Quantidade"
          inputClass="form-control input"
          labelBold
          :max="17"
          v-model="serviceInEditing.quantity"
          :error="$v.serviceInEditing.quantity.$error"
        />
      </b-col>
      <b-col sm="3">
        <InputMoney
          ref="price"
          id="price"
          label="Valor Unitário"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :max="21"
          v-model="serviceInEditing.price"
          :error="$v.serviceInEditing.price.$error"
        />
      </b-col>
      <b-col sm="3">
        <InputDiscount
          v-model="serviceInEditing.discount"
          :max="18"
          :type="serviceInEditing.discountType"
          @changeDiscount="changeDiscount"
        />
      </b-col>
      <b-col sm="3">
        <InputMoney
          ref="totalPrice"
          id="totalPrice"
          label="Total do Serviço"
          inputClass="form-control input"
          labelBold
          disabled
          :max="21"
          :precision="2"
          :value="serviceInEditing.totalPrice"
          :error="$v.serviceInEditing.totalPrice.$error"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputMoney, InputQuantity, InputDiscount } from '@/components/Form';
import { requiredStringNumber } from '@/reusable/validations';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import DiscountMixin from '@/modules/Fiscal/mixins/DiscountMixin';

export default {
  name: 'ServiceTab',
  mixins: [FormatMixin, DiscountMixin],
  components: { InputMoney, InputQuantity, InputDiscount },
  validations: {
    serviceInEditing: {
      price: {
        requiredStringNumber,
      },
      totalPrice: {
        requiredStringNumber,
      },
      quantity: {
        requiredStringNumber,
      },
    },
  },
  computed: {
    ...mapState('nfseComponents', ['serviceInEditing']),
  },
  methods: {
    changeDiscount(data) {
      this.serviceInEditing.discountType = data;

      this.serviceInEditing.totalPrice = this.calculateTotalItem(
        this.serviceInEditing,
      );
    },
  },
  watch: {
    serviceInEditing: {
      handler() {
        this.serviceInEditing.totalPrice = this.calculateTotalItem(
          this.serviceInEditing,
        );
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>
